import React, { useEffect } from "react";

const PublicWidgetPage = ({ agentCode }) => {
useEffect(() => {
    if (!agentCode) return;

    // Remove any previous script
    const existing = document.getElementById("rex-widget-script");
    if (existing) existing.remove();
    // Make agentCode globally available for the widget.js script
    window.REX_AGENT_CODE = agentCode;
    // Create the script element.
    // Load public-widget.js from the SAME origin that's serving this page so
    // it works on whatever port CRA picks (3000, 3001, …). Only use the
    // configured domain when it's a real (non-localhost) production host —
    // otherwise a stale REACT_APP_PUBLIC_WIDGET_DOMAIN pointing at the wrong
    // local port loads nothing and the page shows a blank screen.
    const envDomain = process.env.REACT_APP_PUBLIC_WIDGET_DOMAIN || "";
    const widgetBase =
      envDomain && !/localhost|127\.0\.0\.1/.test(envDomain)
        ? envDomain
        : window.location.origin;
    const script = document.createElement("script");
    script.src = `${widgetBase}/public-widget.js`;
    script.id = "rex-widget-script";
    script.async = true;

    document.body.appendChild(script);

    console.log("Widget injected with agent:", agentCode);

    return () => {
      const s = document.getElementById("rex-widget-script");
      if (s) s.remove();
      delete window.REX_AGENT_CODE;
    };
  }, [agentCode]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
    
      <div id="review-widget"></div>
    </div>
  );
}

export default PublicWidgetPage;
